import script from "./TechnicalPropertySimpleValue.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalPropertySimpleValue.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalPropertySimpleValue.vue?vue&type=style&index=0&id=7f1f5456&lang=less"

const __exports__ = script;

export default __exports__